import { FunctionComponent } from 'react';
import styles from './FancyBox.module.scss';
import classNames from 'classnames';

interface FancyBoxProps {
  title?: string;
  text?: string;
  icon?: React.ReactElement;
}

const FancyBox: FunctionComponent<FancyBoxProps> = ({ title, text, icon }) => {
  return (
    <div className={styles['box']}>
      {icon && <div className={styles['box__icon']}>{icon}</div>}

      {title && <p className={styles['box__title']}>{title}</p>}

      {text && <p className={classNames(styles['box__text'], 'text text--body-1 text--bold')}>{text}</p>}
    </div>
  );
};

export default FancyBox;
